import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=2a321661&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=2a321661&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a321661",
  null
  
)

export default component.exports